import { localePath as buildLocalePath } from '@/utils/localePath'
import { useLanguageStore } from '@/store/language.js'

export default {
  install(app, options) {
    const i18n = options.i18n

    app.config.globalProperties.localePath = (path) => {
      const languageStore = useLanguageStore()
      const locale = languageStore.currentLocale
      return buildLocalePath(path, locale)
    }
  }
}
